import { TAvatarStyle } from 'shared/types/card.interface';

export const getAvatarStyles = (size: TAvatarStyle, fontSize: TAvatarStyle) => ({
  stack: {
    width: size,
    height: size,
  },
  typography: {
    fontSize,
  },
});
